module.exports = __webpack_public_path__ + "img/trevor.0d4e86c7.png";